import { render, staticRenderFns } from "./pricing2.vue?vue&type=template&id=4ae8c285&scoped=true"
import script from "./pricing2.vue?vue&type=script&lang=js"
export * from "./pricing2.vue?vue&type=script&lang=js"
import style0 from "./pricing2.vue?vue&type=style&index=0&id=4ae8c285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7we4hm3wo3mqgjkrzmyg2igq6e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8c285",
  null
  
)

export default component.exports